export const collatedTasks = [
    { key: 'Inbox', name: 'Inbox' },
    { key: 'Today', name: 'Today' },
    { key: 'Scheduled', name: 'Scheduled' },
    { key: 'Important', name: 'Important' },
  ];

  